import React, { VFC, useContext } from 'react';

import { Text } from 'mintel-react-ui';

import ArticleBlock from '../../components/ArticleBlock';
import { MediaColumn, IMAGE_SIZE } from '../../components/BlockColumns';
import { DangerousSpan, useColsCollapsed } from '../../components/common';
import Title from '../../components/Title';
import { cwaUrl } from '../../configuration';
import {
  ArticleBlockProps,
  BlockAnalystProps,
  BlockContentJson,
  ColumnsJson,
  MediaContainerJson,
} from '../../types';
import { assetUri, Asset } from '../../utils/assetUri';
import { PresentModeContext, PublishStatusContext } from '../../utils/contexts';
import useTranslate, { Trans } from '../../utils/translations';
import styles from './BlockAnalyst.scss';

const BlockAnalyst: VFC<BlockAnalystProps> = ({ editor, articleTitle }) => {
  const t = useTranslate();
  const colsCollapsed = useColsCollapsed();
  const publishStatus = useContext(PublishStatusContext);
  const presentMode = useContext(PresentModeContext);

  const mediaColumn: MediaContainerJson = {
    type: 'container',
    elements: {
      image: {
        description: 'A Mintel Analyst',
        gnpd_id: '',
        source:
          editor?.image_url ||
          assetUri('a_mintel_analyst', Asset.Image, publishStatus),
        link: '',
        alt: '',
        type: 'image',
        hidden: false,
      },
    },
    name: 'media',
    hidden: false,
  };

  const columns: ColumnsJson = {
    layout: 'right',
    hidden: false,
    type: 'list',
    list: [],
  };

  const blockContent: BlockContentJson = {
    columns: columns,
  };

  const blockProps: ArticleBlockProps = {
    blockId: 'block-analyst',
    blockBackgroundType: 'bg-white',
    blockContent: blockContent,
    blockBackgroundOpacity: '0.0',
    blockType: 'block-analyst',
    blockLinked: false,
  };

  return (
    <ArticleBlock
      {...blockProps}
      titleCentered
      columns={[
        <MediaColumn
          key={'media'}
          elements={mediaColumn.elements}
          imageSize={IMAGE_SIZE.SMALL}
        />,
        <div key={'text'} className={styles['text-wrapper']}>
          <Title content={t('Meet the expert')} hidden={colsCollapsed} />
          <div className={styles.name}>
            <Text.Heading5>{editor.name}</Text.Heading5>
          </div>
          <Text.Body>{editor.job_title}</Text.Body>
          {!presentMode && (
            <>
              {!!editor.biography && (
                <Text.Body>
                  <DangerousSpan className={styles.bio}>
                    {editor.biography}
                  </DangerousSpan>
                </Text.Body>
              )}
              <div>
                <Text.Body underlineLinks>
                  <a href={`${cwaUrl}/?freetext=editor.name:"${editor.name}"`}>
                    <Trans>Read more by this expert</Trans>
                  </a>
                  {' | '}
                  <a
                    href={`mailto:helpdesk@mintel.com?subject=Feedback about "${articleTitle}"`}
                  >
                    <Trans>Get in touch</Trans>
                  </a>
                </Text.Body>
              </div>
            </>
          )}
        </div>,
      ]}
    />
  );
};

export default BlockAnalyst;
